import React, { useCallback, useEffect, useState, useRef, memo } from 'react';
const testimonials = [{
  name: 'Valentina M.',
  initials: 'VM',
  color: '#0e7490',
  location: 'Buenos Aires',
  role: 'Estudiante de Kinesiología — 4to año',
  quote: 'Tenía parcial de Biomecánica en 3 días. Abrí el Tomo 2, ordené todo rápido y saqué un 8.',
  time: '22:14',
  reply: 'Ese es el objetivo 🙌 Que tengas todo claro y listo para estudiar.'
}, {
  name: 'Tomás R.',
  initials: 'TR',
  color: '#7c3aed',
  location: 'Rosario',
  role: 'Estudiante de Kinesiología — 3er año',
  quote: 'El bono de Signos Vitales me ayudó muchísimo en la práctica hospitalaria. Llegué mucho más seguro.',
  time: '11:30',
  reply: 'Me alegra 😄 Está pensado justo para darte claridad en sala.'
}, {
  name: 'Lucía F.',
  initials: 'LF',
  color: '#b45309',
  location: 'Córdoba',
  role: 'Estudiante de Kinesiología — 2do año',
  quote: 'Me trabé con un TP de evaluación postural, abrí el Tomo 2 y lo resolví en tiempo. Me pusieron un 9.',
  time: '16:52',
  reply: 'Qué bueno 🥹 La idea es que no arranques de cero cada vez.'
}, {
  name: 'Camila B.',
  initials: 'CB',
  color: '#065f46',
  location: 'Tucumán',
  role: 'Estudiante de Kinesiología — 5to año',
  quote: 'Tenía tres finales juntos y cero orden. El Tomo 4 me ayudó a organizar todo en un solo lugar.',
  time: '09:03',
  reply: 'Eso pasa muchísimo 😔 Por eso el sistema está armado para darte claridad.'
}, {
  name: 'Sofía G.',
  initials: 'SG',
  color: '#9f1239',
  location: 'Mendoza',
  role: 'Estudiante de Kinesiología — 4to año',
  quote: 'Las tablas del Tomo 3 me ahorraron horas. Dejé de buscar parámetros en mil lados.',
  time: '19:27',
  reply: 'Exacto 😊 Menos tiempo buscando, más tiempo entendiendo y aprobando.'
}];
function ChevronLeft() {
  return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-297">
      <path d="M15 18l-6-6 6-6" data-id="element-298" />
    </svg>;
}
function ChevronRight() {
  return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-299">
      <path d="M9 18l6-6-6-6" data-id="element-300" />
    </svg>;
}
const WhatsAppChat = memo(function WhatsAppChat({
  t
}: {
  t: (typeof testimonials)[0];
}) {
  return <div className="rounded-xl overflow-hidden shadow-lg w-full shrink-0" style={{
    backgroundColor: '#111b21'
  }} data-id="element-301">
      {/* Header */}
      <div className="flex items-center gap-3 px-4 py-3" style={{
      backgroundColor: '#1f2c34'
    }} data-id="element-302">
        <div className="relative" data-id="element-303">
          <div className="w-10 h-10 rounded-full flex items-center justify-center text-white font-black text-sm" style={{
          backgroundColor: t.color
        }} aria-hidden="true" data-id="element-304">
            {t.initials}
          </div>
          <div className="absolute bottom-0 right-0 w-3 h-3 rounded-full border-2" style={{
          backgroundColor: '#22c55e',
          borderColor: '#1f2c34'
        }} data-id="element-305" />
        </div>
        <div className="flex-1 min-w-0" data-id="element-306">
          <p className="font-semibold text-white m-0 text-sm truncate" data-id="element-307">
            {t.name}
          </p>
          <p className="m-0 text-xs" style={{
          color: '#8696a0'
        }} data-id="element-308">
            {t.role} · {t.location}
          </p>
        </div>
        <div style={{
        color: '#aebac1'
      }} aria-hidden="true" data-id="element-309">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-310">
            <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" data-id="element-311" />
          </svg>
        </div>
      </div>

      {/* Chat area */}
      <div className="px-3 py-4 min-h-[140px] flex flex-col justify-end gap-2" style={{
      backgroundColor: '#0b141a'
    }} data-id="element-312">
        {/* Incoming bubble */}
        <div className="max-w-[92%] self-start relative" data-id="element-313">
          <div className="absolute -left-2 top-0 w-0 h-0" style={{
          borderTop: '8px solid #1f2c34',
          borderLeft: '8px solid transparent'
        }} data-id="element-314" />
          <div className="rounded-lg rounded-tl-none px-3 py-2" style={{
          backgroundColor: '#1f2c34'
        }} data-id="element-315">
            <p className="m-0 text-sm leading-relaxed" style={{
            color: '#e9edef'
          }} data-id="element-316">
              {t.quote}
            </p>
            <div className="flex items-center justify-end gap-1 mt-1" data-id="element-317">
              <span className="text-xs" style={{
              color: '#8696a0'
            }} data-id="element-318">
                {t.time}
              </span>
              <svg width="16" height="11" viewBox="0 0 16 11" fill="none" aria-hidden="true" data-id="element-319">
                <path d="M11.071.653a.457.457 0 0 0-.304-.102.493.493 0 0 0-.381.178l-6.19 7.636-2.011-2.175a.463.463 0 0 0-.336-.153.457.457 0 0 0-.344.153.52.52 0 0 0 0 .688l2.357 2.547a.478.478 0 0 0 .336.178h.025a.46.46 0 0 0 .356-.178l6.537-8.063a.477.477 0 0 0-.046-.71z" fill="#53bdeb" data-id="element-320" />
                <path d="M15.071.653a.457.457 0 0 0-.304-.102.493.493 0 0 0-.381.178l-6.19 7.636-1.2-1.298-.712.737 1.557 1.683a.478.478 0 0 0 .336.178h.025a.46.46 0 0 0 .356-.178l6.537-8.063a.477.477 0 0 0-.046-.71z" fill="#53bdeb" data-id="element-321" />
              </svg>
            </div>
          </div>
        </div>

        {/* Reply bubble */}
        <div className="max-w-[75%] self-end relative mt-1" data-id="element-322">
          <div className="absolute -right-2 top-0 w-0 h-0" style={{
          borderTop: '8px solid #1d4ed8',
          borderRight: '8px solid transparent'
        }} data-id="element-323" />
          <div className="rounded-lg rounded-tr-none px-3 py-2" style={{
          backgroundColor: '#1d4ed8'
        }} data-id="element-324">
            <p className="m-0 text-sm leading-relaxed" style={{
            color: '#e9edef'
          }} data-id="element-325">
              {t.reply}
            </p>
            <div className="flex items-center justify-end gap-1 mt-1" data-id="element-326">
              <span className="text-xs" style={{
              color: '#bfdbfe'
            }} data-id="element-327">
                {t.time}
              </span>
              <svg width="16" height="11" viewBox="0 0 16 11" fill="none" aria-hidden="true" data-id="element-328">
                <path d="M11.071.653a.457.457 0 0 0-.304-.102.493.493 0 0 0-.381.178l-6.19 7.636-2.011-2.175a.463.463 0 0 0-.336-.153.457.457 0 0 0-.344.153.52.52 0 0 0 0 .688l2.357 2.547a.478.478 0 0 0 .336.178h.025a.46.46 0 0 0 .356-.178l6.537-8.063a.477.477 0 0 0-.046-.71z" fill="#bfdbfe" data-id="element-329" />
                <path d="M15.071.653a.457.457 0 0 0-.304-.102.493.493 0 0 0-.381.178l-6.19 7.636-1.2-1.298-.712.737 1.557 1.683a.478.478 0 0 0 .336.178h.025a.46.46 0 0 0 .356-.178l6.537-8.063a.477.477 0 0 0-.046-.71z" fill="#bfdbfe" data-id="element-330" />
              </svg>
            </div>
          </div>
        </div>
      </div>

      {/* Input bar */}
      <div className="flex items-center gap-2 px-3 py-2" style={{
      backgroundColor: '#1f2c34'
    }} data-id="element-331">
        <div style={{
        color: '#8696a0'
      }} aria-hidden="true" data-id="element-332">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" data-id="element-333">
            <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 18c-4.418 0-8-3.582-8-8s3.582-8 8-8 8 3.582 8 8-3.582 8-8 8zm-4-9a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0zm5 0a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0zm-5.5 3.5c.828 1.5 2.5 2.5 4.5 2.5s3.672-1 4.5-2.5" data-id="element-334" />
          </svg>
        </div>
        <div className="flex-1 rounded-full px-4 py-2 text-sm" style={{
        backgroundColor: '#2a3942',
        color: '#8696a0'
      }} data-id="element-335">
          Escribe un mensaje
        </div>
        <div style={{
        color: '#8696a0'
      }} aria-hidden="true" data-id="element-336">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" data-id="element-337">
            <path d="M12 15c1.66 0 3-3V6c0-1.66-1.34-3-3-3S9 4.34 9 6v6c0 1.66 1.34 3 3 3zm5-3c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-2.08c3.39-.49 6-3.39 6-6.92h-2z" data-id="element-338" />
          </svg>
        </div>
      </div>
    </div>;
});
export function Testimonials() {
  const [current, setCurrent] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [slideDirection, setSlideDirection] = useState<'left' | 'right'>('left');
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const total = testimonials.length;
  const goTo = useCallback((index: number, dir: 'left' | 'right') => {
    if (isAnimating) return;
    setSlideDirection(dir);
    setIsAnimating(true);
    setTimeout(() => {
      setCurrent(index);
      setIsAnimating(false);
    }, 250);
  }, [isAnimating]);
  const next = useCallback(() => {
    goTo((current + 1) % total, 'left');
  }, [current, total, goTo]);
  const prev = useCallback(() => {
    goTo((current - 1 + total) % total, 'right');
  }, [current, total, goTo]);
  useEffect(() => {
    intervalRef.current = setInterval(() => next(), 10000);
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [next]);
  const touchStartX = useRef(0);
  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX;
  };
  const handleTouchEnd = (e: React.TouchEvent) => {
    const diff = touchStartX.current - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) next();else prev();
    }
  };
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900" style={{
    background: 'linear-gradient(180deg, rgb(219,234,254) 0%, rgb(239,246,255) 32%, rgb(255,255,255) 100%)'
  }} data-id="element-339">
      <div className="mx-auto max-w-2xl" data-id="element-340">
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-341">
          Lo que dicen los estudiantes{' '}
          <span className="text-blue-700" data-id="element-342">que ya lo usan:</span>
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-8" data-id="element-343">
          +1.800 estudiantes de todo el país ya tienen la carrera organizada.
        </p>

        <div className="relative" onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd} data-id="element-344">
          <button onClick={prev} className="absolute left-0 top-1/2 -translate-y-1/2 translate-x-0 sm:-translate-x-12 z-10 w-10 h-10 rounded-full flex items-center justify-center transition-all hover:scale-110" style={{
          backgroundColor: '#1d4ed8',
          color: '#fff'
        }} aria-label="Anterior testimonio" data-id="element-345">
            <ChevronLeft data-id="element-346" />
          </button>

          <button onClick={next} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-0 sm:translate-x-12 z-10 w-10 h-10 rounded-full flex items-center justify-center transition-all hover:scale-110" style={{
          backgroundColor: '#1d4ed8',
          color: '#fff'
        }} aria-label="Siguiente testimonio" data-id="element-347">
            <ChevronRight data-id="element-348" />
          </button>

          <div className="overflow-hidden rounded-xl mx-10 sm:mx-0" data-id="element-349">
            <div style={{
            transition: isAnimating ? 'none' : 'opacity 0.25s ease, transform 0.25s ease',
            opacity: isAnimating ? 0 : 1,
            transform: isAnimating ? `translateX(${slideDirection === 'left' ? '-30px' : '30px'})` : 'translateX(0)'
          }} data-id="element-350">
              <WhatsAppChat t={testimonials[current]} data-id="element-351" />
            </div>
          </div>

          <div className="mt-4 mx-auto max-w-xs h-1 rounded-full overflow-hidden" style={{
          backgroundColor: 'rgb(226,232,240)'
        }} data-id="element-352">
            <div key={`progress-${current}`} className="h-full rounded-full" style={{
            backgroundColor: '#1d4ed8',
            width: '100%',
            transformOrigin: 'left',
            animation: 'progressFill 10s linear forwards'
          }} data-id="element-353" />
          </div>

          <div className="flex items-center justify-center gap-2 mt-4" data-id="element-354">
            {testimonials.map((_, i) => <button key={i} onClick={() => goTo(i, i > current ? 'left' : 'right')} className="transition-all duration-300 rounded-full" style={{
            width: i === current ? 24 : 8,
            height: 8,
            backgroundColor: i === current ? '#1d4ed8' : 'rgb(203,213,225)'
          }} aria-label={`Ir al testimonio ${i + 1}`} data-id="element-355" />)}
          </div>

          <p className="text-center mt-3 m-0 text-xs text-gray-400" data-id="element-356">
            {current + 1} / {total}
          </p>
        </div>
      </div>
    </section>;
}